exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#login-page-content{display:flex;justify-content:center;margin:20px 0 30px}#login-page-content .centered-items{width:300px;display:flex;flex-direction:column;align-items:stretch}.login-page-title{color:#787878;font-size:20px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/scripts/components/loginPage/loginPage.css
// module id = 42
// module chunks = 0